<template>
  <div class="qywh2 qywh3 animation srcospcur">
    <div class="vidcon">
      <div class="bg"></div>
      <div class="vbid vbids">
        <video
          :key="addKey"
          class="whbfb"
          width="100%"
          height="100%"
          :src="videoSrc"
          controls="controls"
          id="vid1s"
          style="display: inline;"
        ></video>
      </div>
      <div class="tit">
        <p>{{videoTitle}}</p>
      </div>
    </div>

    <div class="vidlist swiper-container-horizontal" v-if="imgs.length>0">
      <Swiper :options="swiperOptionDown" ref="mySwiperVideo">
        <Swiper-slide v-for="(item,index) in imgs" :key="item.id">
          <a
            href="javascript:;"
            title
            :class="item.isActive?'cur':''"
            @click="slideClick(item,index)"
          >
            <div class="ifr" style="display: none;">
              <video
                class="whbfb"
                width="100%"
                height="100%"
                :src="item.videoUrl"
                controls="controls"
                id="vid1s"
                style="display: inline;"
              ></video>
            </div>
            <div class="img">
              <img class="ims" :src="item.imageUrl" width="100%" />
              <span>
                <img src="/static/vidico1.png" width="100%" />
              </span>
            </div>
            <h3>{{item.title}}</h3>
          </a>
        </Swiper-slide>
      </Swiper>

      <div class="swiper-scrollbar">
        <div
          class="swiper-scrollbar-drag"
          style="transform: translate3d(0px, 0px, 0px); width: 536.534px;"
        ></div>
      </div>
      <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    let that = this;
    return {
      addKey: 0,
      videoSrc: "",
      videoTitle: "",
      imgs: this.$props.data || [],
      swiperOptionDown: {
        autoplay: false,
        loop: false,
        slidesPerView: 3,
        spaceBetween: 20,
        scrollbar: ".swiper-scrollbar",
        scrollbarHide: false,
        scrollbarDraggable: true,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 5
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 5
          }
        },
        // on: {
        //   init: function() {
        //     //this.activeIndex
        //     //   $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
        //     that.imgs[this.activeIndex].isActive = true;
        //   },
        //   slideChangeTransitionEnd: function() {
        //     //    $('.vidlists .swiper-slide').removeClass('cur');
        //     //    $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
        //     that.imgs.forEach(item => {
        //       item.isActive = false;
        //     });
        //     that.imgs[this.activeIndex].isActive = true;
        //   }
        // }
        onInit: function(swiper) {
          //this.activeIndex
          //   $('.vidlists .swiper-slide').eq(this.activeIndex).addClass('cur');
          that.imgs[swiper.activeIndex].isActive = true;
        },
        onSlideChangeEnd: function(swiper) {
          that.imgs.forEach(item => {
            item.isActive = false;
          });
          that.imgs[swiper.activeIndex].isActive = true;
        }
      }
    };
  },
  computed: {
    swiperVideo: function() {
      return this.$refs.mySwiperVideo ? this.$refs.mySwiperVideo.$swiper : "";
    }
  },
  mounted() {
    if (this.$props.data.length > 0) {
      let vid = this.$route.query.vid;
      // let nowActiveIndex = 0;
      let setItem = null;
      let arr = this.$props.data.map(item => {
        item.isActive = false;
        if (item.id == vid) {
          // nowActiveIndex = index;
          setItem = item;
        }
        return item;
      });
      arr[0].isActive = true;
      this.videoSrc = arr[0].videoUrl;
      this.videoTitle = arr[0].title;

      this.$set(this.$data, "imgs", arr);
      // this.swiperVideo.slideTo(nowActiveIndex, 200, false);
      if (vid) {
        this.slideClick(setItem);
      }
    }
  },
  methods: {
    slideClick(item) {
      let arr = Object.assign([], this.imgs);
      arr.forEach(cell => {
        if (cell.id == item.id) {
          cell.isActive = true;
        } else {
          cell.isActive = false;
        }
      });
      this.videoSrc = item.videoUrl;
      this.videoTitle = item.title;
      this.$set(this.$data, "imgs", arr);
      this.$router.push({
        name: "news",
        params: { pId: item.node.parentId, cId: item.node.nodeId },
        query: { vid: item.id }
      });
      this.addKey++;
    }
  }
};
</script>